import { Info } from "lucide-react";

export function StatusChangeAlert() {
  return (
    <div className="af-flex af-items-center af-gap-1 af-text-muted-foreground">
      <Info className="af-size-3" />
      <p className="af-text-xs af-leading-none">
        Status will be marked as unaccepted after saving
      </p>
    </div>
  );
}
